import { Directive, HostBinding, OnDestroy } from '@angular/core';

/** Number of skeletons currently rendered. */
let liveSkeletons = 0;
/** Timestamp of the last skeleton being destroyed. */
let lastSkeletonDestroyedAt = 0;
/** Window in which a newly created skeleton counts as a replacement. */
const HANDOFF_WINDOW_MS = 250;

/**
 * Skeletons fade in with a short delay, so fast loads don't flash them. When
 * one skeleton directly replaces another (e.g. the page-level skeleton shown
 * while the user loads is swapped for the one shown while the stores load),
 * that fade must not start over - otherwise the screen blinks.
 *
 * Adds the `skeleton-handoff` host class in that case; the skeleton's styles
 * then skip the fade-in animation.
 */
@Directive({
  selector: '[appSkeletonHandoff]',
  standalone: true,
})
export class SkeletonHandoffDirective implements OnDestroy {
  @HostBinding('class.skeleton-handoff')
  readonly isHandoff =
    liveSkeletons > 0 ||
    performance.now() - lastSkeletonDestroyedAt < HANDOFF_WINDOW_MS;

  constructor() {
    liveSkeletons++;
  }

  ngOnDestroy(): void {
    liveSkeletons--;
    lastSkeletonDestroyedAt = performance.now();
  }
}
